import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import { facebookImportsAPI } from '../../api/facebookImports';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

export const getters = {
  getImports($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getLatestImport($state) {
    return $state.records[0] || null;
  },
};

export const actions = {
  fetch: async ({ commit }, inboxId) => {
    commit(types.SET_FACEBOOK_IMPORTS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await facebookImportsAPI.list(inboxId);
      commit(types.SET_FACEBOOK_IMPORTS, Array.isArray(data) ? data : []);
    } catch {
      // ignore
    } finally {
      commit(types.SET_FACEBOOK_IMPORTS_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, importData) => {
    commit(types.SET_FACEBOOK_IMPORTS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await facebookImportsAPI.create(importData);
      commit(types.ADD_FACEBOOK_IMPORT, data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_FACEBOOK_IMPORTS_UI_FLAG, { isCreating: false });
    }
  },

  pause: async ({ commit }, id) => {
    try {
      const { data } = await facebookImportsAPI.pause(id);
      commit(types.UPDATE_FACEBOOK_IMPORT, data);
    } catch (error) {
      throwErrorMessage(error);
    }
  },

  resume: async ({ commit }, id) => {
    try {
      const { data } = await facebookImportsAPI.resume(id);
      commit(types.UPDATE_FACEBOOK_IMPORT, data);
    } catch (error) {
      throwErrorMessage(error);
    }
  },

  cancel: async ({ commit }, id) => {
    try {
      const { data } = await facebookImportsAPI.cancel(id);
      commit(types.UPDATE_FACEBOOK_IMPORT, data);
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};

export const mutations = {
  [types.SET_FACEBOOK_IMPORTS_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_FACEBOOK_IMPORTS]: MutationHelpers.set,
  [types.ADD_FACEBOOK_IMPORT]: MutationHelpers.setSingleRecord,
  [types.UPDATE_FACEBOOK_IMPORT]: MutationHelpers.update,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
